import _ from 'lodash';
import { ImageHotspot } from 'react-image-hotspot';

type ImageHotspotProps = React.ComponentProps<typeof ImageHotspot>;
type TValueType = NonNullable<ImageHotspotProps['value']>[number];

export const convertStringToPointsKeyArray = (input: string): TValueType | null => {
  const split = input.split(',');
  const key = split[0];
  const value = _.chunk(split.splice(1).map(parseFloat), 2);
  if (value.length === 4) return { key, value } as TValueType;
  return null;
}